<template>
  <div class="nuttrema-brand-image" :class="[ theme ? `theme-${theme}` : '', { 'hide-in-expanded': hideInExpanded }]">
    <template v-if="link">
      <router-link
         tag="a"
         activeClass="is-active"
        :to="{ name: link }">
        <img class="nuttrema-brand-image__image--white" src="~assets/images/dc-logo-small-white.svg" :alt="$t('label.diet_creator_logo_alt')">
        <img class="nuttrema-brand-image__image--gray" src="~assets/images/dc-logo-small-gray.svg" :alt="$t('label.diet_creator_logo_alt')">
      </router-link>
    </template>
    <template v-else>
      <img class="nuttrema-brand-image__image--white" src="~assets/images/dc-logo-small-white.svg" :alt="$t('label.diet_creator_logo_alt')">
      <img class="nuttrema-brand-image__image--gray" src="~assets/images/dc-logo-small-gray.svg" :alt="$t('label.diet_creator_logo_alt')">
    </template>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-brand-image',
  props: {
    link: {
      required: false,
      default: null,
    },
    hideInExpanded: {
      type: Boolean,
      default: false,
      required: false,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  .nuttrema-brand-image {
    display: flex;
    align-items: center;
    justify-content: center;

    &.hide-in-expanded {
      .is-expanded & {
        display: none;
      }
    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    img {
      width: 80%;
    }

    // default
    .nuttrema-brand-image__image--white {
      display: block;
    }

    .nuttrema-brand-image__image--gray {
      display: none;
    }
    // default


    // global theme settings
    .nuttrema-theme-professional-topography & {
      .nuttrema-brand-image__image--white {
        display: none;
      }
      .nuttrema-brand-image__image--gray {
        display: block;
      }
    }

    .nuttrema-theme-professional-turquoise & {
      .nuttrema-brand-image__image {
        display: none;
      }
      .nuttrema-brand-image__image--white {
        display: block;
      }
    }
    // end ~ global theme settings

    &.theme-white {
      .nuttrema-brand-image__image--white {
        display: block;
      }
      .nuttrema-brand-image__image--gray {
        display: none;
      }
    }

    &.theme-gray {
      .nuttrema-brand-image__image--white {
        display: none;
      }
      .nuttrema-brand-image__image--gray {
        display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/images/nuttrema-brand-image.vue